import { completions } from '../state/completions';
import { dayFilter, viewMode } from '../state/filters';
import { week } from '../state/schedule';

/** Bottom view-filter tabs over the one board (v1 model: filters, not separate panes). */
export function Tabs() {
  const doneCount = Object.keys(completions.value).filter((id) =>
    week.value?.days.some((d) => d.calls.some((c) => c.id === id)),
  ).length;
  const tab = (active: boolean) =>
    `tap flex-1 py-3 text-center text-sm font-bold ${active ? 'text-brand-600' : 'text-slate-500'}`;
  return (
    <nav
      class="fixed inset-x-0 bottom-0 z-30 flex border-t border-slate-200 bg-white pb-[env(safe-area-inset-bottom)]"
      aria-label="View"
    >
      <button
        class={tab(viewMode.value === 'week')}
        aria-pressed={viewMode.value === 'week'}
        onClick={() => {
          viewMode.value = 'week';
        }}
      >
        This Week
      </button>
      <button
        class={tab(viewMode.value === 'resolved')}
        aria-pressed={viewMode.value === 'resolved'}
        data-testid="tab-resolved"
        onClick={() => {
          viewMode.value = 'resolved';
          dayFilter.value = 'all'; // resolved view is week-wide (v1 rule)
        }}
      >
        Resolved{doneCount ? ` · ${doneCount}` : ''}
      </button>
    </nav>
  );
}
